// DEP-NS-v1 size table for WideBundle calculator (.calc-row-selectors).
// Kept in a separate file to avoid touching other template tables.
(function () {
  window.__DEP_NS_V1_WB_SIZE_TABLE__ = {
    "70":  { "B": "S",  "C": "S",  "D": "M",  "DD/E": "",    "DDD/F": "",    "G": "",     "H": ""     },
    "75":  { "B": "S",  "C": "S+", "D": "M",  "DD/E": "M+",  "DDD/F": "",    "G": "",     "H": ""     },
    "80":  { "B": "S+", "C": "M",  "D": "M+", "DD/E": "L",   "DDD/F": "L+",  "G": "",     "H": ""     },
    "85":  { "B": "M",  "C": "M+", "D": "L",  "DD/E": "L+",  "DDD/F": "XL",  "G": "XL+",  "H": ""     },
    "90":  { "B": "M+", "C": "L",  "D": "L+", "DD/E": "XL",  "DDD/F": "XL+", "G": "2XL",  "H": "2XL+" },
    "95":  { "B": "L+", "C": "L+", "D": "XL", "DD/E": "XL+", "DDD/F": "2XL", "G": "2XL+","H": "3XL"  },
    "100": { "B": "XL", "C": "XL", "D": "XL+","DD/E": "2XL", "DDD/F": "2XL+","G": "3XL", "H": "3XL+" },
    "105": { "B": "2XL","C": "2XL","D": "2XL","DD/E": "2XL+","DDD/F": "3XL", "G": "3XL+","H": ""     },
    "110": { "B": "3XL","C": "3XL","D": "3XL","DD/E": "3XL", "DDD/F": "3XL+","G": "",     "H": ""     }
  };
})();

